import { coerceBooleanProperty } from '@angular/cdk/coercion';
import ClassConstructor from './constructor';

export interface ICanDisable {
  /**
   * @deprecated Use `phxDisabled` instead.
   */
  disabled: boolean;
  phxDisabled: boolean;
}

type CanDisableCtor = ClassConstructor<ICanDisable>;

export default function mixinDisabled<T extends ClassConstructor<{}>>(base: T): CanDisableCtor & T {
  return class extends base {
    private _disabled: boolean = false;
    get disabled(): boolean {
      return this._disabled;
    }
    set disabled(value: boolean) {
      this._disabled = coerceBooleanProperty(value);
    }

    get phxDisabled(): boolean {
      return this._disabled;
    }
    set phxDisabled(value: boolean) {
      this._disabled = coerceBooleanProperty(value);
    }

    constructor(...args: any[]) {
      super(...args);
    }
  };
}
